import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class UnifiedProfileSkill extends BaseModel {
  static override constructorName = 'UnifiedProfileSkillModel'

  'skill_id': number = 0
  skill: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(UnifiedProfileSkill)

export interface SaveUnifiedProfileSkill {
  'skill_id': number
}
